import { Input } from '@attentive-platform/stem-ui';
import { isValidEmail } from '../Utils/HelperFunctions';

export const EmailInput = ({ value, onChange, name = 'email', size = 'medium', showError = true, disabled = false, width }) => {
  const hasError = showError && value && !isValidEmail(value);
  return (
    <Input
      name={name}
      color='primary'
      size={size}
      fullWidth
      placeholder='Email of user'
      value={value}
      onChange={e => {
        onChange('email', e.target.value);
      }}
      error={hasError}
      helperText={hasError && 'Invalid email'}
      disabled={disabled}
      width={width}
    />
  );
};
